import React, { useState } from 'react';
import { 
  FaCar, FaShieldAlt, FaClock, FaCheckCircle, 
  FaMapMarkerAlt, FaCalendarAlt, FaPhoneAlt, FaStar,
  FaCrown, FaGem, FaAward
} from 'react-icons/fa';
import '../style.css';

const ExcellenceInMotion = () => {
  const [hoveredCard, setHoveredCard] = useState(null);
  const [activeFeature, setActiveFeature] = useState(0);

  const features = [
    { icon: <FaCar />, title: "Premium Fleet", desc: "Luxury sedans to spacious SUVs" },
    { icon: <FaMapMarkerAlt />, title: "GPS Tracking", desc: "Real-time journey monitoring" },
    { icon: <FaCalendarAlt />, title: "Easy Booking", desc: "24/7 online reservation" },
    { icon: <FaPhoneAlt />, title: "Live Support", desc: "Instant assistance available" }
  ];

  const handleBookNow = () => {
    console.log('Booking initiated');
  };

  return (
    <section className="gsc-section">
      {/* Light Background Particles */}
      <div className="gsc-particles">
        {[...Array(8)].map((_, i) => (
          <div 
            key={i} 
            className={`gsc-particle gsc-particle-${i % 4}`}
            style={{
              '--delay': `${i * 0.3}s`,
              '--duration': `${12 + i * 2}s`,
            }}
          />
        ))}
      </div>

      <div className="gsc-container">
        {/* Compact Heading */}
        <div className="gsc-heading">
          <div className="gsc-title-group">
            <div className="gsc-main-title">
              <span className="gsc-title-line">
                The Gold Standard of Varanasi Travel
              </span>
              <span className="gsc-title-highlight">
                <span className="gsc-title-text">Varanasi Travel</span>
                <span className="gsc-title-glow"></span>
              </span>
            </div>
            <div className="gsc-subtitle">
              <span className="gsc-subtitle-dot"></span>
              <span>Excellence in Motion</span>
              <span className="gsc-subtitle-dot"></span>
            </div>
          </div>
        </div>

        {/* Compact Content Grid */}
        <div className="gsc-content">
          {/* Description Box */}
          <div className="gsc-description-box">
            <div className="gsc-description-header">
              <div className="gsc-description-icon">
                <FaCar />
              </div>
              <h3>VNS Tour And Travels</h3>
            </div>
            
            <div className="gsc-description-text">
              <p>
                Offering <span className="gsc-text-highlight">safe, reliable, and comfortable rides</span> 
                for locals, tourists, and business travelers. Whether you need airport transfers from 
                Babatpur, a cab from Varanasi Junction, or local rides, we ensure timely pickup.
              </p>
              <p>
                Book sightseeing rides to Kashi Vishwanath Temple, Sarnath, or the famous Ganga Aarti. 
                Our <span className="gsc-text-highlight">transparent billing, flexible booking, and wide car options</span> 
                make us the trusted choice.
              </p>
            </div>

            {/* Features Grid */}
            <div className="gsc-features-compact">
              {features.map((feature, index) => (
                <div 
                  key={index}
                  className={`gsc-feature-compact ${activeFeature === index ? 'gsc-feature-active' : ''}`}
                  onMouseEnter={() => setActiveFeature(index)}
                  onClick={() => setActiveFeature(index)}
                >
                  <div className="gsc-feature-icon-compact">
                    {feature.icon}
                  </div>
                  <div className="gsc-feature-content-compact">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Stats & CTA Side */}
          <div className="gsc-side-content">
            {/* Stats Cards */}
            <div className="gsc-stats-compact">
              <div 
                className={`gsc-stat-compact ${hoveredCard === 'availability' ? 'gsc-stat-hover' : ''}`}
                onMouseEnter={() => setHoveredCard('availability')}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="gsc-stat-badge">24/7</div>
                <div className="gsc-stat-content-compact">
                  <div className="gsc-stat-icon-compact">
                    <FaClock />
                    <div className="gsc-stat-pulse"></div>
                  </div>
                  <div className="gsc-stat-text">
                    <h4>Availability</h4>
                    <p>Round the clock</p>
                  </div>
                </div>
              </div>

              <div 
                className={`gsc-stat-compact ${hoveredCard === 'safety' ? 'gsc-stat-hover' : ''}`}
                onMouseEnter={() => setHoveredCard('safety')}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="gsc-stat-badge">100%</div>
                <div className="gsc-stat-content-compact">
                  <div className="gsc-stat-icon-compact">
                    <FaShieldAlt />
                    <div className="gsc-stat-pulse"></div>
                  </div>
                  <div className="gsc-stat-text">
                    <h4>Safety Record</h4>
                    <p>Zero incidents</p>
                  </div>
                </div>
              </div>

              <div 
                className={`gsc-stat-compact ${hoveredCard === 'rating' ? 'gsc-stat-hover' : ''}`}
                onMouseEnter={() => setHoveredCard('rating')}
                onMouseLeave={() => setHoveredCard(null)}
              >
                <div className="gsc-stat-badge">4.9★</div>
                <div className="gsc-stat-content-compact">
                  <div className="gsc-stat-icon-compact">
                    <FaStar />
                    <div className="gsc-stat-pulse"></div>
                  </div>
                  <div className="gsc-stat-text">
                    <h4>Rating</h4>
                    <p>5000+ reviews</p>
                  </div>
                </div>
              </div>
            </div>

            {/* CTA Button */}
            <div className="gsc-cta-compact">
              <button 
                className="gsc-book-button"
                onClick={handleBookNow}
              >
                <span className="gsc-button-text">Book Now</span>
                <div className="gsc-button-icon">
                  <FaCheckCircle />
                </div>
                <div className="gsc-button-glow"></div>
                <div className="gsc-button-spark">
                  <span></span>
                  <span></span>
                  <span></span>
                </div>
              </button>
              
              <div className="gsc-cta-features-compact">
                <div className="gsc-cta-feature-item">
                  <FaCheckCircle className="gsc-feature-check" />
                  <span>Instant Confirmation</span>
                </div>
                <div className="gsc-cta-feature-item">
                  <FaCheckCircle className="gsc-feature-check" />
                  <span>No Hidden Charges</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Floating Gold Elements */}
        <div className="gsc-floating-icons">
          <div className="gsc-floating-icon gsc-float-1">
            <FaCrown />
          </div>
          <div className="gsc-floating-icon gsc-float-2">
            <FaGem />
          </div>
          <div className="gsc-floating-icon gsc-float-3">
            <FaAward />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExcellenceInMotion;